import { memo as Memo, useCallback, useEffect } from 'react';
import { gsap } from 'gsap';

const ZiggyEyes = Memo(() => {
	useEffect(() => {
		window.addEventListener('mousemove', mouseMove);
		return () => {
			window.removeEventListener('mousemove', mouseMove);
		};
	}, []);

	const mouseMove = useCallback((e) => {
		const size = -5;
		const winWPart = window.innerWidth / 2;
		const winHPart = window.innerHeight / 2;
		const x = ((winWPart - e.clientX) / winWPart) * size;
		const y = ((winHPart - e.clientY) / winHPart) * size;

		gsap.killTweensOf('.ziggyEyes-e');
		gsap.killTweensOf('.ziggyEyes-m');

		gsap.to('.ziggyEyes-e', { duration: 0.5, x, y });
		gsap.to('.ziggyEyes-m', { duration: 0.5, x: x * 0.8, y: y * 0.8 });
	}, []);

	return (
		<svg
			className='ziggyEyes svg-max'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 222.3 184'>
			<path
				className={'fill'}
				d='M126.4,34,99.3,0,87.6,43.3l-37-22.1-.4,35.5L9.6,50.2,25.4,82.4,0,99.5l31.7,10.1,1.2,32.3,33.8-21.8,10.9,33.5,25.9-29.3,27.3,24.3,15.8-35.2L188,127.2l-7.2-38L222.3,79,183.2,63.1l16.6-41.5-36,19.2L156.9,4.4Z'
			/>
			<path
				className={`defaultStyle`}
				d='M122.8,132.72s-6.65,5.92-3,16.72c3.39,6.3,1.53,13,.22,16.27a12.71,12.71,0,0,0-.89,5.56l.68,11.23,15.12.08'
			/>
			<path
				className={`defaultStyle`}
				d='M86.6,132.72s6.65,5.92,3,16.72c-3.39,6.3-1.53,13-.22,16.27a12.71,12.71,0,0,1,.89,5.56l-.68,11.23-15.12.08'
			/>
			<path
				className={`ziggyEyes-m fillWhite`}
				d='M102.2,87.6v4.1H97.9V87.6Z'
			/>
			<path
				className={`ziggyEyes-e fillWhite`}
				d='M85.22,79l-1.83-2.21c-.15.24-.28.42-.38.56a3.55,3.55,0,0,1-1.44,1.32,4.85,4.85,0,0,1-2.2.49,5.5,5.5,0,0,1-2.74-.65,4.38,4.38,0,0,1-1.76-1.76,5.12,5.12,0,0,1-.6-2.49,4.81,4.81,0,0,1,1-3.19,4,4,0,0,1,2.63-1.44l-.26-.45a4.72,4.72,0,0,1-.54-1.11A4.06,4.06,0,0,1,77,66.87,3.51,3.51,0,0,1,77.49,65a3.84,3.84,0,0,1,1.57-1.4,5.52,5.52,0,0,1,2.5-.52,5,5,0,0,1,3.15.86,4.23,4.23,0,0,1,1.52,2.24,6.08,6.08,0,0,1,.25,2.17H82.92a8,8,0,0,0,0-.82c0-.85-.47-1.28-1.26-1.28a1.11,1.11,0,0,0-.79.29,1,1,0,0,0-.3.74,1.36,1.36,0,0,0,.17.69,6.91,6.91,0,0,0,.54.83L89.07,79ZM80.7,75.52A1.8,1.8,0,0,0,80.64,73a1.92,1.92,0,0,0-1.34-.51A1.81,1.81,0,0,0,78,72.9a1.64,1.64,0,0,0-.48,1.28,1.76,1.76,0,0,0,.52,1.33,1.86,1.86,0,0,0,1.33.5A1.77,1.77,0,0,0,80.7,75.52Z'
			/>
			<path
				className={`ziggyEyes-e fillWhite`}
				d='M123.08,79l-1.83-2.21c-.15.24-.28.42-.38.56a3.52,3.52,0,0,1-1.45,1.32,4.79,4.79,0,0,1-2.2.49,5.53,5.53,0,0,1-2.74-.65,4.36,4.36,0,0,1-1.75-1.76,5,5,0,0,1-.61-2.49,4.87,4.87,0,0,1,1-3.19,4,4,0,0,1,2.64-1.44l-.27-.45A4.32,4.32,0,0,1,115,68.1a4.06,4.06,0,0,1-.18-1.23,3.59,3.59,0,0,1,.53-1.88,3.87,3.87,0,0,1,1.58-1.4,5.45,5.45,0,0,1,2.49-.52,5.05,5.05,0,0,1,3.16.86,4.21,4.21,0,0,1,1.51,2.24,5.87,5.87,0,0,1,.25,2.17h-3.55a8.17,8.17,0,0,0,0-.82c0-.85-.46-1.28-1.25-1.28a1.1,1.1,0,0,0-.79.29,1,1,0,0,0-.31.74,1.47,1.47,0,0,0,.17.69,7.23,7.23,0,0,0,.55.83L126.92,79Zm-4.53-3.51a1.65,1.65,0,0,0,.5-1.25,1.67,1.67,0,0,0-.56-1.3,1.9,1.9,0,0,0-1.34-.51,1.81,1.81,0,0,0-1.26.44,1.67,1.67,0,0,0-.48,1.28,1.73,1.73,0,0,0,.53,1.33,1.86,1.86,0,0,0,1.33.5A1.73,1.73,0,0,0,118.55,75.52Z'
			/>
		</svg>
	);
});

export default ZiggyEyes;
